export class RateOfExchangeProperties {
  roeid: number;
  name: string;
  supplier: string;
  officeIDs: string;
  byDefaultROE: number;
  isByAirlines: boolean;
  isDeleted: boolean;
  agencyBranch: string;
  byAgencyROE: number;
  isByAgency: boolean;
  byAgentROE: number;
  isByAgent: boolean;
  byAirlines: ByAirlinesRateOfExchangeProperties[];
}

export class ByAirlinesRateOfExchangeProperties {
  airlineROEID: number;
  airlines: string[] = [];
  byDefaultROE: number;
  isBySector: boolean;
  byAgencyROE: number;
  isByAgency: boolean;
  byAgentROE: number;
  isByAgent: boolean;
  isDeleted: boolean;
  bySectorList: BySectorRateOfExchangeProperties[];
}

export class BySectorRateOfExchangeProperties {
  sectorROEID: number;
  airlineID: number;
  expiryDate: string;
  byDefaultROE: number;
  isTravelDate: boolean;
  travelingDate = new ROEDates();
  isBookingDate: boolean;
  bookingDate = new ROEDates();
  isLocationInclusuion: boolean;
  locationInclusuion = new LocationByROE();
  isLocationExclusuion: boolean;
  locationExclusuion = new LocationByROE();
  isTripType: boolean;
  tripTypes = new TripType();
  isDeleted: boolean;
  byAgencyROE: number;
  isByAgency: boolean;
  byAgentROE: number;
  isByAgent: boolean;
}

export class ROEDates {
  fromDate: string;
  toDate: string;
}

export class LocationByROE {
  from: string[] = [];
  to: string[] = [];
  via: string[] = [];
}

export class TripType {
  oneWay: boolean;
  roundTrip: boolean;
  multicity: boolean;
}
export class TypeOfRateOfExchangeFunction {
  locationInclusion = 1;
  locationExclusion = 2;
  travllingDate = 3;
  bookingDate = 4;
  tripType = 5;
}
